import CloseIcon from './CloseIcon.jsx'
export default CloseIcon



// WEBPACK FOOTER //
// ./src/components/CloseIcon/index.js